import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AudioService {
  playBeep(type: number): void {
    const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gain = audioCtx.createGain();

    let frequency = 440;
    let duration = 0.1;
    let waveType: OscillatorType = 'square';

    switch (type) {
      case 1:
        frequency = 440; // A4
        duration = 0.1;
        waveType = 'square';
        break;
      case 2:
        frequency = 523.25; // C5
        duration = 0.15;
        waveType = 'sine';
        break;
      case 3:
        frequency = 659.25; // E5
        duration = 0.2;
        waveType = 'triangle';
        break;
      case 4:
        frequency = 250; // G4
        duration = 0.4;
        waveType = 'sawtooth';
        break;
      case 5:
        frequency = 150; // C4
        duration = 0.5;
        waveType = 'sawtooth';
        break;
      default:
        frequency = 440;
        duration = 0.1;
        waveType = 'square';
    }

    oscillator.type = waveType;
    oscillator.frequency.setValueAtTime(frequency, audioCtx.currentTime);

    gain.gain.setValueAtTime(0.1, audioCtx.currentTime);
    oscillator.connect(gain);
    gain.connect(audioCtx.destination);

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + duration);

    oscillator.onended = () => {
      gain.disconnect();
      oscillator.disconnect();
      audioCtx.close();
    };
  }
}
